'use client';

import { useMemo } from 'react';
import { Filters } from '@funkey/shared';
import { MULTIPLE_CATEGORIES_FILTER_CONFIG } from '~/features/activities/ActivityFilterBar/config';
import { useActivitySearchCtx } from './client/context';
type SubCategory = {
  id: number;
  name?: string | null;
};

/**
 * Shared source of truth for the subcategory chip row: it shows only when exactly one category is
 * selected and that category has children. Consumed by the filter bar (renders the chips), the hero
 * wrapper (grows mobile height for the extra row) and the filters overlay (matches the translate).
 */
export function useSubCategoryRow(): {
  subCategories: SubCategory[] | null;
  showSubCategoryRow: boolean;
} {
  const state = useActivitySearchCtx().useFilters('categories', 'subCategories');
  const categoriesData = MULTIPLE_CATEGORIES_FILTER_CONFIG.useDataLoader(state.value);
  const subCategories = useMemo<SubCategory[] | null>(() => {
    if (state.value.categories.length !== 1) return null;
    return categoriesData.categories?.find(category => category.id === state.value.categories[0])?.children?.filter(Filters.nonnull).map(child => ({
      id: child.id,
      name: child.name
    })) || null;
  }, [state.value.categories, categoriesData.categories]);
  return {
    subCategories,
    showSubCategoryRow: !!subCategories?.length && state.value.categories.length === 1
  };
}